<script setup lang="ts">
  import { ColoredButton } from '@/shared/ui';

  defineProps<{
    isSaving: boolean;
    isFormValid: boolean;
    isLoadingMember: boolean;
    loadError: boolean;
  }>();

  defineEmits<{
    cancel: [];
    save: [];
  }>();
</script>

<template>
  <div class="px-6 py-8 flex justify-end gap-3 border-t border-gray-02 flex-shrink-0">
    <ColoredButton
      text="Cancelar"
      outlined
      color="gray-03"
      :disabled="isSaving"
      @click="$emit('cancel')"
    />
    <ColoredButton
      :disabled="!isFormValid || isSaving || isLoadingMember || loadError"
      :text="isSaving ? 'Salvando...' : 'Salvar'"
      @click="$emit('save')"
    />
  </div>
</template>
